import {ConfigKeys} from '@drl/core/enums/config-keys.enum';

export class WorkingTimingsConfig {
  id?: number;
  configKey?: ConfigKeys;
  configValue?: WorkingTimings;
}

export interface WorkingTimings {
  workingTimings: DailyWorkingTimings[];
  workingMsg: string;
  nonWorkingMsg: string;
}

export class DailyWorkingTimings {
  day: string;
  startTimeHours: string;
  startTimeMinutes: string;
  startTimeAmPm: string;
  endTimeHours: string;
  endTimeMinutes: string;
  endTimeAmPm: string;
}
